import { useEffect, useRef } from 'react';
import { axiosLasta } from 'config';
import { handleResponseError } from 'utils/axiosHelper/axiosErrorHandlerHelper';

export default function useInterceptors() {
    const interceptors = useRef({ responseInterceptorId: null });

    useEffect(() => {
        // Eject previous interceptor
        if (interceptors.current.responseInterceptorId !== null) {
            axiosLasta.interceptors.response.eject(interceptors.current.responseInterceptorId);
        }

        // OLD CODE (before BEAST-8060 workaround):
        // const { isKeycloakIntegrationEnabled } = useFeatureFlag();
        // const responseInterceptor = isKeycloakIntegrationEnabled ? handleInterceptorResponseError : handleResponseError;

        // TEMPORARY WORKAROUND (BEAST-8060): Refresh token interceptor is always disabled
        // Some business logic endpoints return 401/403 which would incorrectly trigger token refresh.
        // Token lifetime is 4-5 hours, so auto-logout after expiration is acceptable for Lasta.
        // TODO: Remove this workaround once business logic endpoints are fixed to not return 401/403
        // Always use handleResponseError (without refresh) regardless of Keycloak feature flag
        const responseInterceptor = handleResponseError;

        // Add new interceptor
        const responseInterceptorId = axiosLasta.interceptors.response.use(
            (response) => response,
            (error) => responseInterceptor(error)
        );

        // Store ID for cleanup
        interceptors.current = { responseInterceptorId: responseInterceptorId };

        // Cleanup on unmount or next run
        return () => {
            axiosLasta.interceptors.response.eject(responseInterceptorId);
            interceptors.current = { responseInterceptorId: null };
        };
    }, []);
}
